import React from 'react';
import { pluralizeWithCount } from 'utils/string_utils';

const humanizedValues = {
  days: 'Day',
  weeks: 'Week',
  months: 'Month',
};

const DueDateBadge = ({ amount, unit }) => (
  <div className="ml-8 p-4-8 fz-sm c-gray-darker bdrs-base bg-gray-light f-smooth fw-b f-sh-0">
    Due in {pluralizeWithCount(amount, humanizedValues[unit])}
  </div>
);

export default DueDateBadge;
